import { render, staticRenderFns } from "./BookingCommodityChart.vue?vue&type=template&id=b2762228"
import script from "./BookingCommodityChart.vue?vue&type=script&lang=js"
export * from "./BookingCommodityChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports